import React, { useEffect, useState } from 'react';
import { getVersion } from '../api/publicApi';
import { getSettings } from '../api/authApi';
import '../../styles/shared/Footer.css';

const SITE_URL = 'https://neoneko.org/status';
const GIT_URL = 'https://git.neoneko.org/NeoNeko/NeoStatus';

// Module-level memos so version + footer text are fetched once per session even
// if the footer is mounted on several pages.
let cachedVersion = null;
let cachedFooterText = null;

export default function Footer() {
  const [version, setVersion] = useState(cachedVersion);
  const [footerText, setFooterText] = useState(cachedFooterText);

  useEffect(() => {
    let active = true;
    if (!cachedVersion) {
      getVersion()
        .then((res) => {
          cachedVersion = res.data?.version || null;
          if (active) setVersion(cachedVersion);
        })
        .catch(() => {});
    }
    if (cachedFooterText === null) {
      getSettings()
        .then((res) => {
          cachedFooterText = res.data?.footerText || '';
          if (active) setFooterText(cachedFooterText);
        })
        .catch(() => {});
    }
    return () => {
      active = false;
    };
  }, []);

  return (
    <footer className="app-footer">
      {footerText && <span className="app-footer__custom">{footerText}</span>}
      <span className="app-footer__text">
        Powered by{' '}
        <a className="app-footer__link" href={SITE_URL} target="_blank" rel="noreferrer">
          NeoStatus
        </a>
        {version && (
          <>
            {' '}
            <a className="app-footer__version" href={GIT_URL} target="_blank" rel="noreferrer">
              v{version}
            </a>
          </>
        )}
      </span>
    </footer>
  );
}
